// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__33HVl","col":"styles_col__jZN7j"};